import Money from '~/lib/money';

export const formatAmount = (amount, symbol = false, currency = 'EUR') => {
  const money = new Money(amount, currency);
  return money.format({ symbol });
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
